import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createBlock(_component_q_banner, { class: "bg-grey-2 rounded-borders" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ total: _ctx.total, isLoading: _ctx.isLoading })), () => [
        _createTextVNode(" This report will contain "),
        _withDirectives(_createElementVNode("strong", null, _toDisplayString(_ctx.total), 513), [
          [_vShow, !_ctx.isLoading]
        ])
      ]),
      _withDirectives(_createVNode(_component_q_icon, { name: "fa fa-circle-notch fa-spin" }, null, 512), [
        [_vShow, _ctx.isLoading]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.postsText) + ". ", 1)
    ]),
    _: 3
  }))
}